import * as moment from 'moment-timezone';

export const formatDate = (
  date: string | Date,
  timezone: string,
  format: string
): string => {
  if (!date || !timezone || !format) {
    return '';
  }

  return moment(date).tz(timezone).format(format);
}


export const statusMap = (status: string)=> {
    const statuses = [
      { name: "WillCall", value: ["willcall"] },
      { name: "Pending", value: ['marketplaced','pending', 'offered', 'accepted'] },
      { name: "Onway", value: ["onway"] },
      { name: "Arrived", value: ["arrived"] },
      { name: "In Vehicle", value: ["started"] },
      { name: "Exiting", value: ["completed"] },
      { name: "Canceled", value: ["cancelled"] },
      { name: "Rode", value: ["finished"] },
    ];
    const mappedStatus = statuses.find((s) => s.value.includes(status));

    return mappedStatus ? mappedStatus.name : status;
  }
